// umlaut-check: skip — "ErklaerungAbschnitt" ist ein Komponentenname
// (technischer Bezeichner), die sichtbaren Texte tragen Umlaute korrekt.

import React, {useEffect, useMemo, useState} from "react";
import useAnalysisData from "../../SalesAnalysis/useAnalysisData.js";
import FolienRahmen from "./FolienRahmen.jsx";
import Folie1Quellen from "./Folie1Quellen.jsx";
import Folie1Fluss from "./Folie1Fluss.jsx";
import Folie3Wochenbedarf from "./Folie3Wochenbedarf.jsx";
import Folie4Szenarien from "./Folie4Szenarien.jsx";
import Folie5Marken from "./Folie5Marken.jsx";
import Folie6Bestellmenge from "./Folie6Bestellmenge.jsx";
import Folie7Lkw from "./Folie7Lkw.jsx";
import Folie8Sicherheit from "./Folie8Sicherheit.jsx";

/**
 * "So rechnet der Bereich" (Auftrag S7, Wortlaut Thorsten 22.09.2026): acht
 * Folien, die die Berechnung des gesamten Bereichs präsentationstauglich
 * erklären - gedacht, um sie im Meeting mit Jürgen und Oskar Schritt für
 * Schritt zu zeigen. Hält die Auswahl des Beispiel-Farbtons zentral, damit
 * Folie 3, 4 und 6 an einem durchgängigen Beispiel erzählen; lädt dessen
 * Artikel-Blatt-Daten einmal für alle drei Folien.
 */
export default function ErklaerungAbschnitt({einstellungen, kennzahlen}) {
    const [beispielArtikel, setBeispielArtikel] = useState("327080");
    const {data: artikelRohdaten, loading: artikelLaedt} = useAnalysisData(`/cosmos/daten/artikel/${beispielArtikel}`, {});
    const [artikelDaten, setArtikelDaten] = useState(null);

    useEffect(() => {
        if (artikelRohdaten) {
            setArtikelDaten(artikelRohdaten);
        }
    }, [artikelRohdaten]);

    const folien = useMemo(
        () => [
            {id: "quellen", titel: "Woher die Zahlen kommen", inhalt: <Folie1Quellen kennzahlen={kennzahlen} />},
            {id: "fluss", titel: "Wie die Zahlen zusammenlaufen", inhalt: <Folie1Fluss />},
            // „Was ist echter Verbrauch?“ vorerst ausgeblendet (Auftrag #59,
            // 29.09.2026): Begründung und Kontrollzahl werden fachlich neu
            // geprüft - lieber keine Folie als eine falsche.
            {
                id: "wochenbedarf",
                titel: "Wochenbedarf und Saison",
                inhalt: (
                    <Folie3Wochenbedarf
                        beispielArtikel={beispielArtikel}
                        onBeispielArtikelAendern={setBeispielArtikel}
                        artikelDaten={artikelDaten}
                        ladeGerade={artikelLaedt}
                    />
                ),
            },
            {
                id: "szenarien",
                titel: "Der Bestand in die Zukunft",
                inhalt: (
                    <Folie4Szenarien
                        beispielArtikel={beispielArtikel}
                        onBeispielArtikelAendern={setBeispielArtikel}
                        artikelDaten={artikelDaten}
                        ladeGerade={artikelLaedt}
                    />
                ),
            },
            {id: "marken", titel: "Die vier Marken", inhalt: <Folie5Marken />},
            {
                id: "bestellmenge",
                titel: "Wie viel bestellen?",
                inhalt: (
                    <Folie6Bestellmenge
                        beispielArtikel={beispielArtikel}
                        onBeispielArtikelAendern={setBeispielArtikel}
                        artikelDaten={artikelDaten}
                        ladeGerade={artikelLaedt}
                    />
                ),
            },
            {id: "lkw", titel: "Vom Vorschlag zum LKW", inhalt: <Folie7Lkw einstellungen={einstellungen} />},
            {id: "sicherheit", titel: "Wie sicher sind die Zahlen?", inhalt: <Folie8Sicherheit einstellungen={einstellungen} />},
        ],
        [beispielArtikel, artikelDaten, artikelLaedt, einstellungen, kennzahlen]
    );

    return <FolienRahmen folien={folien} />;
}
